import { render, staticRenderFns } from "./task-menu-btn.vue?vue&type=template&id=48850c1e"
import script from "./task-menu-btn.vue?vue&type=script&lang=js"
export * from "./task-menu-btn.vue?vue&type=script&lang=js"
import style0 from "./task-menu-btn.vue?vue&type=style&index=0&id=48850c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports